import { stringify } from 'query-string';

import { getScreenHintParam } from './getScreenHint';

export const getRedirectToScreenUrl = (returnTo: string): string => {
  const _returnTo = returnTo || window.location.href;
  const queryParams: Record<string, string> = {
    returnTo: new URL(_returnTo).toString(),
    screenHint: getScreenHintParam(),
  };

  return `${window.location.origin}/api/v1/auth?${stringify(queryParams, {
    skipEmptyString: true,
  })}`;
};

export const redirectToScreen = (returnTo: string): void => {
  window.location.replace(getRedirectToScreenUrl(returnTo));
};
